import { ReactNode } from "react";
import { Navigate } from "react-router-dom";

// List of possible roles (example: change to match your system)
type UserRole =
  | "SuperAdministrateur"
  | "Administrateur"
  | "Enseignant"
  | "Comptable";

// Props for ProtectedRoute
interface ProtectedRouteProps {
  allowedRoles?: UserRole[]; // Optional array of roles
  children: ReactNode;
}

export default function ProtectedRoute({
  allowedRoles,
  children,
}: ProtectedRouteProps) {
  const auth = localStorage.getItem("user");

  if (!auth) return <Navigate to="/login" replace />;

  const user = JSON.parse(auth);

  switch (user.role_id) {
    case 1:
      user.role = "Administrateur";
      break;
    case 2:
      user.role = "Comptable";
      break;
    case 3:
      user.role = "Enseignant";
      break;
    default:
      break;
  }

  // 1 Logged in but role NOT allowed
  if (allowedRoles && !allowedRoles?.includes(user.role as UserRole)) {
    return <Navigate to="/unauthorized" replace />;
  }

  // 2 Access granted
  return <>{children}</>;
}
